import { CountUp } from 'countup.js';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel';

let accordions = document.querySelectorAll('.accordion .toggle');
let panels = document.querySelectorAll('.accordion .panel');
accordions.forEach(function (accordion, index) {
    console.log(accordion, index);
    accordion.addEventListener("click", function () {
        console.log('click', index);
        if (panels[index]) {
            if (panels[index].classList.contains('active')) {
                console.log('contains');
                panels[index].classList.remove('active');
            } else {
                console.log('not contains');
                panels.forEach(panel => {
                    panel.classList.remove('active');
                });

                panels[index].classList.add('active');
            }
        }
    });
});

if (panels[0]) {
    panels[0].classList.add('active');
    let panelRow = panels[0].querySelector('.panel-row');
    if (panelRow) {
        panelRow.setAttribute('aria-hidden', 'false');
    }
}

window.onload = () => {
    let statsNumbers = document.querySelectorAll('.stats-number--number.animate-countup');
    [...statsNumbers].forEach(number => {
        let countUp = new CountUp(number, number.dataset.countup);
        countUp.start();
    });
}

(function ($) {
    $(function () {
        $(".hero-carousel, .testimonials-carousel, .text-carousel, .scrolling-image-carousel, .media-coverage-carousel").each(function () {
            const carouselNav = !!$(this).data('carouselNav');
            const numItems = $(this).data('numItems');
            let responsiveOptions = {};

            if ($(this).hasClass('media-coverage-carousel') || $(this).hasClass('scrolling-image-carousel')) {
                responsiveOptions = {
                    0: {
                        items: 1
                    },
                    576: {
                        items: 1
                    },
                    992: {
                        items: 2
                    }
                };
            }

            $(this).owlCarousel({
                items: numItems ? parseInt(numItems) : 1,
                loop: carouselNav ? true : false,
                autoplayHoverPause: true,
                autoplay: !!$(this).data('autoscroll'),
                nav: carouselNav,
                dots: false,
                responsive: responsiveOptions
            });
        });

        let owlEvents = $(".events-gallery-carousel").owlCarousel({
            items: $(".events-gallery-carousel").data('numItems') ? parseInt($(this).data('numItems')) : 1,
            loop: !!$(".events-gallery-carousel").data('carouselNav') ? true : false,
            autoplayHoverPause: true,
            nav: true,
            dots: false,
            responsive: {
                0: {
                    items: 1
                },
                576: {
                    items: 2
                },
                992: {
                    items: 3
                }
            }
        });

        if (!!$(".events-gallery-carousel").data('autoscroll')) {
            owlEvents.trigger('play.owl.autoplay');
        }


        const historyCarouselNav = !!$(".history-carousel-container").data('carouselNav');
        const historyNumItems = $(".history-carousel-container").data('numItems');
        const historyAutoscroll = $(".history-carousel-container").data('autoscroll');
        let owlHistory = $(".history-carousel-container").owlCarousel({
            items: historyNumItems ? parseInt(historyNumItems) : 1,
            loop: historyCarouselNav ? true : false,
            autoplayHoverPause: true,
            autoplayTimeout: 12000,
            nav: historyCarouselNav,
            dots: false,
        });

        if (!!historyAutoscroll) {
            owlHistory.trigger('play.owl.autoplay');
        }

        owlHistory.on('translated.owl.carousel', function (event) {
            let heading = $(event.target).find('.owl-item').eq(event.item.index).find('.history-slide').data('heading');
            $('.timeline-nav span').removeClass('active');
            $('.timeline-nav span[data-heading="' + heading + '"]').addClass('active');
        });

        $('.timeline-nav button').on('click', function () {
            let heading = $(this).data('heading');
            let targetIndex = 0;

            $('.history-slide').each(function (index) {
                if ($(this).data('heading') === heading && !$(this).closest('.owl-item').hasClass('cloned')) {
                    targetIndex = $(this).closest('.owl-item').index();
                    return false;
                }
            });

            let realIndex = $('.owl-item').not('.cloned').index($('.owl-item').eq(targetIndex));

            owlHistory.trigger('to.owl.carousel', [realIndex, 300]);
            $('.timeline-nav button').removeClass('active');
            $(this).addClass('active');
        });

        $('.timeline-nav span').first().addClass('active');

        $('.owl-play').on('click', function () {
            let owl = $(this).parent().siblings('.owl-carousel');
            owl.trigger('play.owl.autoplay', [12000]);
            $(this).addClass('active');
            $(this).siblings('.owl-stop').removeClass('active');
        });

        $('.owl-stop').on('click', function () {
            let owl = $(this).parent().siblings('.owl-carousel');
            owl.trigger('stop.owl.autoplay');
            $(this).addClass('active');
            $(this).siblings('.owl-play').removeClass('active');
        });

        $('.owl-prev').attr('aria-label', 'Previous');
        $('.owl-next').attr('aria-label', 'Next');
    });

    $('a[href^="#"]').on('click', function (event) {
        let href = this.getAttribute('href');
        let target = $(href);

        if (href == '#') {
            event.preventDefault();
        }
        else if (target.length && href !== '#main') {
            event.preventDefault();
            $('html, body').stop().animate({
                scrollTop: target.offset().top
            }, 500);
        }
    });

    $(function () {
        let newsItems = $('.news-item');
        let postsToShow = 10;
        let postsLoaded = postsToShow;

        if (postsLoaded >= newsItems.length) {
            $('.load-more-button').hide();
        }

        newsItems.slice(postsToShow).hide();

        if (newsItems.length > postsToShow) {
            $('.load-more-button').show();
        }

        $('.load-more-button').on('click', function () {
            newsItems.slice(postsLoaded, postsLoaded + postsToShow).fadeIn();
            postsLoaded += postsToShow;

            if (postsLoaded >= newsItems.length) {
                $('.load-more-button').hide();
            }
        });
    });

    // Compliance


})(jQuery);